import React from 'react';
import { Card } from 'react-bootstrap';
import Chart from 'react-apexcharts';
import { formatCurrency } from '../../utils/formatters';

const RevenueChart = ({ categories, revenueData, totalRevenue, isLoading }) => {
  const chartOptions = {
    chart: {
      type: 'area',
      fontFamily: 'Inter, sans-serif',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    colors: ['#10b981'],
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.5,
        gradientToColors: ['#34d399'],
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0.1,
        stops: [0, 100],
      },
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      borderColor: '#f1f1f1',
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    xaxis: {
      type: 'category',
      categories: categories || [],
      labels: {
        minHeight: 20,
        maxHeight: 20,
        style: {
          colors: '#9ca3af',
          fontSize: '12px',
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      title: {
        text: 'Revenue ($)',
        style: {
          color: '#374151',
          fontSize: '13px',
          fontWeight: 500,
        },
      },
      labels: {
        offsetY: 0,
        minWidth: 40,
        style: {
          colors: '#9ca3af',
          fontSize: '12px',
        },
        formatter: function(val) {
          return formatCurrency(val, false);
        },
      },
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy',
      },
      y: {
        formatter: function(value) {
          return formatCurrency(value);
        },
      },
    },
    annotations: {
      yaxis: totalRevenue > 0 ? [
        {
          y: totalRevenue / (categories?.length || 1),
          borderColor: '#dc3545',
          strokeDashArray: 5,
          label: {
            borderColor: '#dc3545',
            style: {
              color: '#fff',
              background: '#dc3545',
              fontSize: '11px',
              fontWeight: 600,
            },
            text: `Avg: ${formatCurrency(totalRevenue / (categories?.length || 1))}`,
            position: 'left',
          },
        },
      ] : [],
    },
  };

  const chartSeries = [
    {
      name: 'Revenue',
      data: revenueData || [],
    },
  ];

  return (
    <Card style={{ borderRadius: '12px', border: '1px solid #e5e5e5', height: '100%', minHeight: '420px' }}>
      <Card.Body className="p-4 d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="font-weight-bold mb-1">Revenue Report</h5>
            <p className="text-muted small mb-0">Daily revenue from leads (cost)</p>
          </div>
          <div className="text-end">
            <p className="text-muted small mb-0">Total Revenue</p>
            <h4 className="font-weight-bold text-success mb-0">
              {formatCurrency(totalRevenue || 0)}
            </h4>
          </div>
        </div>
        
        <div className="flex-grow-1 d-flex align-items-center">
          {isLoading ? (
            <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: '320px' }}>
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <Chart
              className="w-100"
              options={chartOptions}
              series={chartSeries}
              type="area"
              height="320"
            />
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default RevenueChart;